import { Divider } from '@chakra-ui/react';
import CustomStepper from 'components/ui/custom-stepper/CustomStepper';
import StepperProvider, { useStepperContext } from 'components/ui/custom-stepper/CustomStepperContext';
import HeaderBarInternal from 'components/ui/HeaderBarInternal';
import CompanyRecipientsList from '../components/CompanyRecipientsList';
import FormCompany from '../components/FormCompany';
import CompaniesProvider from '../contexts/CompaniesContext';

export default function PageCreateCompany() {
  return (
    <StepperProvider
      steps={['Dados da Empresa', 'Membros']}
    >
      <CompaniesProvider>
        <HeaderBarInternal
          title="Novo cliente"
          backTo="/clientes"
        >
          <CustomStepper />
        </HeaderBarInternal>
        
        <Divider />

        <CurrentStep />
        
      </CompaniesProvider>
    </StepperProvider>
  )
}

function CurrentStep() {
  const { activeStep, previousStep, nextStep } = useStepperContext();
  
  if (activeStep === 0)
    return <FormCompany onNext={nextStep} />;
  
  if (activeStep === 1)
    return <CompanyRecipientsList onBack={previousStep} />;
  
  return null;
}
